import React from 'react';
import styled from 'styled-components';

import ProjectNotification from './ProjectNotification';
import FeedbackNotification from './FeedbackNotification';

import { primaryColor, primaryColorDark } from '~theme';

const Notification = ({ notification, editing }) => {
  switch (notification.action) {
    case 'EVENT_TYPE_FEEDBACK_REQUEST':
      return (
        <Wrapper seen={notification.seen}>
          <FeedbackNotification notification={notification} editing={editing} />
        </Wrapper>
      );
    case 'EVENT_TYPE_PROJECT_INFO':
    case 'EVENT_TYPE_PROJECT_PARTICIPANT_ADDED':
    case 'EVENT_TYPE_PROJECT_TASK_ASSIGNED':
    case 'EVENT_TYPE_PROJECT_TASK_CHANGED':
    case 'EVENT_TYPE_PROJECT_TASK_COMMENT_ADDED':
      return (
        <Wrapper seen={notification.seen}>
          <ProjectNotification notification={notification} editing={editing} />
        </Wrapper>
      );
    default:
      return <Wrapper>Tuntematon viestityyppi</Wrapper>;
  }
};

const Wrapper = styled.div`
  color: white;
  border-bottom: 1px solid white;
  background-color: ${props => (props.seen ? primaryColor : primaryColorDark)};
  min-height: 70px;
  width: 100%;

  display: flex;
`;

export default Notification;
